'use strict';function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}

const _=require('pulsar-utils/dist-es6/_');let

GroupTreeExtensions=function(){
function GroupTreeExtensions(groupTree){_classCallCheck(this,GroupTreeExtensions);
this._groupTree=groupTree;
}GroupTreeExtensions.prototype.

walkTreeFromRoot=function walkTreeFromRoot(fn,maxDepth){
_walkTreeFromRoot({children:this._groupTree},fn,void 0,void 0,maxDepth);
};GroupTreeExtensions.

extend=function extend(groupTree){
_.ensureInstanceOf([Object,Array],groupTree);

return new GroupTreeExtensions(_.toArray(groupTree));
};return GroupTreeExtensions}();


function _walkTreeFromRoot(group,fn){let currentDepth=arguments.length>2&&arguments[2]!==void 0?arguments[2]:0;let currentPath=arguments.length>3&&arguments[3]!==void 0?arguments[3]:'';let maxDepth=arguments.length>4&&arguments[4]!==void 0?arguments[4]:null;
fn(group,currentDepth,currentPath);

const nextDepth=currentDepth+1;
if(_.exists(maxDepth)&&nextDepth>MaxDepth){
return;
}

for(const[index,child]of group.children.entries()){
_walkTreeFromRoot(child,fn,nextDepth,currentPath+`${currentDepth>0?'.children.':''}${index}`,maxDepth);
}
}

module.exports=GroupTreeExtensions.extend;
//# sourceMappingURL=groupTreeExtensions.js.map
